import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const token = localStorage.getItem("token"); // 👈 or however you store your token

  fetch(`${API_BASE_URL}/api/Dashboard/GetDashboard`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`, // 👈 Add token here
    },
  })
    .then((res) => {
      if (!res.ok) throw new Error("Failed to fetch");
      return res.json();
    })
    .then((data) => {
      if (data.length > 0 && data[0].dashboardJson) {
        const parsed = JSON.parse(data[0].dashboardJson);
        setDashboardData(parsed);
      }
      setLoading(false);
    })
    .catch((err) => {
      console.error("Error fetching dashboard:", err);
      setLoading(false);
    });
}, []);


  if (loading) return <div>Loading...</div>;
  if (!dashboardData) return <div>No data available</div>;

  // Build stats dynamically
  const stats = [
    { id: 1, title: "Open Cases", value: dashboardData.OpenCases },
    { id: 2, title: "Hearings Today", value: dashboardData.HearingsToday },
    { id: 3, title: "Clients", value: dashboardData.Clients },
  ];

  return (
    <div className="page">
      <main className="content">
        {/* Stats */}
        <section className="stats">
          {stats.map((s) => (
            <div key={s.id} className="stat-card">
              <div className="stat-title">{s.title}</div>
              <div className="stat-value">{s.value}</div>
              <div className="stat-sub">Updated just now</div>
            </div>
          ))}
        </section>

        {/* Main grid */}
        <section className="main-grid">
          <div className="left-column">
            <Card title="Upcoming Hearings">
              <ul className="list">
                {dashboardData.UpcomingHearings?.map((h, i) => (
                  <li key={i} className="list-item">
                    <div>
                      <div className="item-title">
                        {h.CaseNumber} — {h.PartyName}
                      </div>
                      <div className="item-sub">
                        {h.CourtName} •{" "}
                        {new Date(h.HearingDate).toLocaleDateString()}
                      </div>
                    </div>
                    <span className="item-extra">{h.ChamberName}</span>
                  </li>
                ))}
              </ul>
            </Card>

            <Card title="Recent Activity" subtitle="(Static Example)">
              <ul className="list">
                <li className="list-item">
                  You can also bind recentActivity from API
                </li>
              </ul>
            </Card>
          </div>

          <div className="right-column">
            <Card title="Calendar">
              <div className="calendar">
                Mini calendar / embed your calendar here
              </div>
            </Card>

            <Card title="Recent Clients">
              <ul className="list">
                {dashboardData.RecentClients?.map((c, i) => (
                  <li key={i} className="list-item">
                    {c.PartyName}{" "}
                    <span className="item-sub">
                      {c.CaseCount} case{c.CaseCount > 1 ? "s" : ""}
                    </span>
                  </li>
                ))}
              </ul>
            </Card>
          </div>
        </section>
      </main>
    </div>
  );
}

function Card({ title, subtitle, children }) {
  return (
    <div className="card">
      <div className="card-header">
        <h3>{title}</h3>
        {subtitle && <span>{subtitle}</span>}
      </div>
      <div className="card-body">{children}</div>
    </div>
  );
}
